import React from "react";
import { DollarSign, Eye, TriangleAlert } from "lucide-react";
import { Badge } from "antd";
import { NumberFormatter } from "utils/index";

const InvoiceCard = ({invoiceList, type='Overdue'}) => {
  if (!invoiceList || invoiceList?.length === 0) return null;

  const isOverDue = type === 'Overdue';

  const styleClassMap = {
    'Overdue': {
      'backgroundColor': "rgb(251 44 54)",
      'cardClass': 'red-white',
      'textColor': 'text-red-600',
      'amountClass': 'text-red-600 dark:text-red-100',
      'badgeTextClass': 'text-red-600 dark:text-red-300',
      'payHoverClass': 'bg-red-600 hover:bg-red-700',
    },
    'Due Soon': {
      'backgroundColor': "rgb(234 179 8)",
      'cardClass': 'yellow-white',
      'textColor': 'text-yellow-600',
      'badgeTextClass': 'text-yellow-600 dark:text-yellow-300',
      'payHoverClass': 'bg-yellow-600 hover:bg-yellow-700',
    }
  };

  const badgeStyle = {
      backgroundColor: styleClassMap[type].backgroundColor,
      color: "#ffffff",
      fontSize: "9px",
    }
    
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-1.5 mb-2">
        {isOverDue && <TriangleAlert className="w-3.5 h-3.5 text-red-600 dark:text-red-400" />}
        <h3 className={`text-[12px] ${styleClassMap[type].badgeTextClass}`}>
          {isOverDue ? 'Overdue - Urgent' : type}
        </h3>
        <Badge
          count={invoiceList?.length}
          size="small"
          style={{
            ...badgeStyle,
            border: "none",
          }}
        />
      </div>

      {Array.isArray(invoiceList) && invoiceList.map((item, idx) => (
        <div
          key={idx}
          className={`card-border-s rounded-xl ${styleClassMap[type].cardClass}`}
        >
          <div className="items-start gap-1.5 pb-2 pt-3 px-3">
            <div className="flex items-start justify-between gap-2">
              {invoiceList &&
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-1.5 mb-1 flex-wrap">
                  <h4 className="text-[13px] title-text">{item.invoice_title}</h4>
                  <Badge
                    count={`${item.days_due}`}
                    style={{
                      ...badgeStyle,
                      height: "16px",
                      minWidth: "auto",
                    }}
                  />
                </div>
                <p className="text-[11px] line-clamp-1 muted-text">{item.invoice_description}</p>
              </div>
              }

              <div className="text-right shrink-0">
                <div className={`text-[15px] font-semibold ${styleClassMap[type].amountClass}`}>
                  $ {NumberFormatter(item.inv_amount_due)}
                </div>
                <p className="text-[9px] muted-text">Due: {item.inv_due_date}</p>
              </div>
            </div>
          </div>

          <div className="pb-6 px-3 pb-2 mt-6">
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-1 flex-wrap">
                {/* <p className="status-indicator normal text-[8px] bg-slate-50">{item.department}</p> */}
                <p className="status-indicator normal text-[8px] bg-slate-50">{item.inv_number}</p>
              </div>
              <div className="flex items-center gap-1.5 shrink-0">
                <button 
                  className="status-indicator font-medium transition-al rounded-lg h-6 text-[10px] px-2 bg-white text-foreground"
                  onClick={()=>window.location.href = `/console/my-invoices/${item.inv_id}/view`}
                >
                  <Eye className="w-3 h-3" />
                </button>
                {/* <button className={`inline-flex items-center justify-center whitespace-nowrap font-medium transition-all rounded-lg gap-1.5 h-6 text-[10px] px-2 text-white ${styleClassMap[type].payHoverClass}`}>
                  <DollarSign className="w-3 h-3 mr-1" />
                  Pay
                </button> */}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InvoiceCard;
